export default {
    state: () => ({
        StayConnectedForm: {
            title: '',
            subtitle: '',
            text: ''
        },
        filters: {}
    }),

    mutations: {
        setStayConnectedForm(state, payload) {
            state.StayConnectedForm.title = payload.title
            state.StayConnectedForm.subtitle = payload.subtitle
            state.StayConnectedForm.text = payload.text
        },
        setState(state, payload) {
            if (typeof payload !== 'object') {
                return
            }

            for (const key in payload) {
                state[key] = Object.assign(state[key] || {}, payload[key])
            }
        },
        setFilters(state, payload) {
            state.filters = payload
        }
    }
}